import Anchor from "./PopperAnchor.svelte"
import Arrow from "./PopperArrow.svelte"
import Content, {
  type PopperContentProps as PopperContentPropsActual,
} from "./PopperContent.svelte"
import Root from "./PopperRoot.svelte"

export const SIDE_OPTIONS = ["top", "right", "bottom", "left"] as const
export const ALIGN_OPTIONS = ["start", "center", "end"] as const

export type Side = (typeof SIDE_OPTIONS)[number]
export type Align = (typeof ALIGN_OPTIONS)[number]
export type PopperContentProps = PopperContentPropsActual

export const Popper = {
  Root,
  Anchor,
  Content,
  Arrow,
}
